<template>
    <PriceSpecificationHotel :product="product" />
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { HotelProduct } from '@/api/Cart/cart.interfaces';
    import PriceSpecificationHotel from '@/components/shared/PriceSpecification/Hotel/PriceSpecificationHotel.vue';

    export default defineComponent({
        name: 'HotelModalPrice',
        components: { PriceSpecificationHotel },
        props: {
            product: {
                type: Object as PropType<HotelProduct>,
                required: true,
            },
        },
    });
</script>
